import { createGenerator } from '../sprouts-engine';
import { pack } from '../content/reading';

export const generateProblem = createGenerator(pack);
